import React from 'react'
import { BreadcrumbsPDP } from './BreadcrumbsPDP'
import { BreadcrumbsPLP } from './BreadcrumbsPLP'

export type CategoryBreadcrumb = {
    category_name: string
    category_url_key: string
    category_url_path: string
    category_level?: number
}

interface BreadcrumbsProps {
    separator?: string
    rootText?: string
    urlSuffix?: string
    urlPrefix?: string
}

interface CategoryBreadcrumbsProps extends BreadcrumbsProps {
    category: {
        name: string
        breadcrumbs?: CategoryBreadcrumb[]
    }
    product?: never
}

export type RequiredCategoryBreadcrumbsProps = Required<
    Omit<CategoryBreadcrumbsProps, 'product'>
>

interface ProductBreadcrumbsProps extends BreadcrumbsProps {
    product: {
        name: string
        categories: {
            name: string
            url_path: string
        }[]
    }
    category?: never
}

export type RequiredProductBreadcrumbsProps = Required<
    Omit<ProductBreadcrumbsProps, 'category'>
>

export const Breadcrumbs = ({
    rootText = 'Home',
    separator = '/',
    urlSuffix = '',
    urlPrefix = '/category',
    category,
    product
}: CategoryBreadcrumbsProps | ProductBreadcrumbsProps): JSX.Element | null => {
    const breadcrumbProps = {
        rootText,
        separator,
        urlSuffix,
        urlPrefix,
        category,
        product
    }

    if (category)
        return (
            <BreadcrumbsPLP
                {...(breadcrumbProps as RequiredCategoryBreadcrumbsProps)}
            />
        )

    if (product)
        return (
            <BreadcrumbsPDP
                {...(breadcrumbProps as RequiredProductBreadcrumbsProps)}
            />
        )

    return null
}
